var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex w-100 content-center justify-center pt-4"},[_c('div',{staticClass:"copyright"},[_c('p',[_vm._v(" © "+_vm._s(_vm.getCurrentYear)+" "),_c('a',{attrs:{"href":"https://www.limburg.be/"}},[_vm._v("Provinciale Uitleendienst Limburg")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }